import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from './auth.service';
import { NavbarRerenderService } from '../helper/navbar-rerender.service';
import {
  getAuthErrorMessage,
  isAuthHttpError,
  shouldHandleSessionExpiry,
} from './auth-http-error.util';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const navbarRerenderService = inject(NavbarRerenderService);
  const message = inject(NzMessageService);

  return next(req).pipe(
    catchError((err) => {
      if (isAuthHttpError(err) && shouldHandleSessionExpiry()) {
        message.error(getAuthErrorMessage(err), { nzDuration: 3500 });

        if (router.url === '/listings') {
          authService.logout('/listings');
        } else {
          authService.logout();
        }
        navbarRerenderService.changeMessage('rerender');
      }
      return throwError(() => err);
    })
  );
};
